module.exports = __webpack_public_path__ + "img/Container-Outline.59d4d2ef.png";